<section class="checklist-section-container">
	@if (checklistTemplate() === null || isEditMode()) {
		<div class="section-title" [class.m-b-sm]="isChecklistEnabled() || isEditMode()">
			<p class="select-label">{{ 'checklist' | translate }}</p>
			@if (!isEditMode()) {
				<div class="section-title-toggle">
					<p class="toggle-state">
						{{ isChecklistEnabled() ? ('on' | translate) : ('off' | translate) }}
					</p>
					<mat-slide-toggle
						[checked]="isChecklistEnabled()"
						(change)="toggleChecklist($event)"
						color="primary"
					/>
				</div>
			} @else {
				<div class="delete-checklist" (click)="deleteChecklist()">
					<mat-icon svgIcon="delete" />
					<span>{{ 'delete_checklist' | translate }}</span>
				</div>
			}
		</div>
		@if (isChecklistEnabled() || isEditMode()) {
			<div class="section-content">
				<checklist-options
					(checklistOptionsChanged)="checklistOptionsChanged($event)"
					(cancelPressed)="cancelChecklistChanges()"
					(savePressed)="saveChecklistChanges($event)"
					[showActionButtons]="isExistingWorkOrder"
					[checklistTemplate]="checklistTemplate() || parsedChecklistFormControl"
				/>
			</div>
		}
	} @else {
		<mat-expansion-panel
			class="au-section-panel full-title-width"
			hideToggle
			[expanded]="isPanelOpen()"
			(afterCollapse)="afterCollapseHandler()"
			(afterExpand)="afterExpandHandler()"
		>
			<mat-expansion-panel-header class="section-header">
				<mat-panel-title>
					<span class="arrow" [class.rotate-right-90]="!isPanelOpen()">
						<mat-icon class="icon accent-icon" svgIcon="arrow_down"></mat-icon>
					</span>
					<span class="section-name m-r-sxs">{{ 'checklist' | translate }}</span>
					<checklist-progress
						[totalCount]="totalOptionsCount()"
						[completedCount]="completedOptionsCount()"
					/>
				</mat-panel-title>
				<mat-panel-description class="edit-checklist-btn">
					<button mat-mini-fab class="surface-fab" (click)="editChecklist($event)">
						<mat-icon svgIcon="pencil" />
					</button>
				</mat-panel-description>
			</mat-expansion-panel-header>
			<checklist-items
				[checklistTemplate]="checklistTemplate()"
				(checklistTemplateChange)="checklistTemplateChanged($event)"
			/>
		</mat-expansion-panel>
	}
</section>
